import { render } from "./AccessibilityStatementEs.vue?vue&type=template&id=234f9f1e&scoped=true"
import script from "./AccessibilityStatementEs.vue?vue&type=script&lang=js"
export * from "./AccessibilityStatementEs.vue?vue&type=script&lang=js"

import "./AccessibilityStatementEs.vue?vue&type=style&index=0&id=234f9f1e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-234f9f1e"]])

export default __exports__